import {Component, OnInit, ViewContainerRef,} from '@angular/core';
import {EditDataService} from "../services/edit-data.service";
import CustomStore from 'devextreme/data/custom_store';
import {ToastsManager} from 'ng2-toastr/ng2-toastr';

@Component({
  selector: 'app-filiation',
  templateUrl: './filiation.component.html',
  providers: [ToastsManager],
  styleUrls: ['./filiation.component.scss']
})
export class FiliationComponent {
  dataSource: any = {};
  public password: any;
  public passwordIsRequired = true;

  constructor(public editDataService: EditDataService
    , public toastr: ToastsManager
    , public vRef: ViewContainerRef) {

    this.toastr.setRootViewContainerRef(vRef);
    this.password = this.editDataService.password;
    this.dataSource.store = this.getFiliationStore(this.editDataService, this.toastr);
  }

  customizeColumns(columns) {
    columns[0].width = 140;
    columns[4].width = 140;
  }

  onContentReady(e) {
    e.component.option("loadPanel.enabled", false);
    let isInserting = !!e.element[0].innerHTML.match(/(dx-row-inserted)/gi);
    if (isInserting) {
      this.passwordIsRequired = true;
    }
    /*  e.component.columnOption("command:edit", {
     visibleIndex: -1,
     width: 80
     });*/
  }

  /**
   * Для подсчёта высоты грида на ходу
   * @returns {string}
   */
  countHeight() {
    return 420 + "%";
  }

  onCellPrepared(e) {
    if (e.rowType === "data" && e.column.command === "edit") {
      let isEditing = e.row.isEditing,
        $links = e.cellElement.find(".dx-link");
      $links.text("");
      if (isEditing) {
        $links.filter(".dx-link-save").addClass("dx-icon-save");
        $links.filter(".dx-link-cancel").addClass("dx-icon-revert");
      } else {
        $links.filter(".dx-link-edit").addClass("dx-icon-edit");
        $links.filter(".dx-link-delete").addClass("dx-icon-trash");
      }
    }
  }

  /**
   * чтобы устанавливать обязательность/не обязательность пароля налету
   * @param value
   */
  requireHandler(value) {
    this.passwordIsRequired = value;
  }

  ngOnInit() {
  }

  getFiliationStore(editDataService, toastr) {
    return new CustomStore({

      load: () => {
        return editDataService
          .getFiliations()
          .then(response => {
            let json = response.json();
            json = json.map(function (item) {
              item.password = "";
              return item;
            });
            return {
              data: json,
              totalCount: json.length
            }
          })
          .catch(error => {
            let json = error.json();
            toastr.error(json.message);
            return {
              data: {},
              totalCount: 0
            }
          });
      },

      insert: data => {
        return editDataService
          .sendNewFiliation(data)
          .then(function (response) {
            return response.json();
          })
          .catch(error => {
            let json = error.json();
            if (json instanceof Array && json.length > 0) {
              toastr.error(json[0].message);
              return {};
            }
            toastr.error(json.message);
            return {};
          });
      },

      update: function (oldData, newData) {
        newData["id"] = oldData.id;
        return editDataService
          .sendFiliation(newData)
          .then(function (response) {
            return response.json();
          })
          .catch(error => {
            let json = error.json();
            if (json instanceof Array && json.length > 0) {
              toastr.error(json[0].message);
              return {};
            }
            toastr.error(json.message);
            return {};
          });
      },

      remove: function (item) {
        return editDataService
          .sendRemoveFiliation(item)
          .then(function (response) {
            return response.json();
          })
          .catch(error => {
            let json = error.json();
            toastr.error(json.message);
            return {};
          });
      }
    });
  }
}



// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/filiation/filiation.component.ts